import script from "./SeleryManagment.vue?vue&type=script&setup=true&lang=js"
export * from "./SeleryManagment.vue?vue&type=script&setup=true&lang=js"

import "./SeleryManagment.vue?vue&type=style&index=0&id=71efd8f0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71efd8f0"]])

export default __exports__